import { render, staticRenderFns } from "./DSInfoIcon.vue?vue&type=template&id=601c1ba8&scoped=true&"
import script from "./DSInfoIcon.vue?vue&type=script&lang=js&"
export * from "./DSInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c1ba8",
  null
  
)

export default component.exports